/* Scroll-controlled, short-GOP alpha video; the image sequence remains a fallback. */
(function () {
  if (window.RoniniScrollVideo) return;
  window.RoniniScrollVideo = function (image, scene, createFallback, count) {
    const video = document.createElement('video');
    const ua = navigator.userAgent || '';
    const apple = /iPad|iPhone|iPod/.test(ua) || (navigator.vendor === 'Apple Computer, Inc.' && !/Chrome|Chromium|Edg|OPR/.test(ua));
    const source = apple
      ? (video.canPlayType('video/mp4; codecs="hvc1"') ? image.dataset.scrollHevc : '')
      : (video.canPlayType('video/webm; codecs="vp9"') ? image.dataset.scrollWebm : '');
    if (!source || count < 2) return null;
    const mobile = window.matchMedia('(max-width: 991px)');
    let near = !window.IntersectionObserver, enabled = true, destroyed = false;
    let progress = 0, loaded = false, raf = 0, loadTimer = 0, seekTimer = 0, observer, fallback;
    const working = () => near && enabled && !destroyed && !document.hidden && !fallback;
    // data-start on the image: the frame shown at progress 0 (default: frame 5 on phones, 0 on desktop).
    const startAt = () => (image.dataset.start ? Math.max(0, Math.min(count - 1, Number(image.dataset.start) || 0)) : mobile.matches ? Math.min(5, count - 1) : 0);
    video.className = 'sticky-scene-image is-active';
    video.setAttribute('aria-hidden', 'true');
    video.muted = true; video.playsInline = true; video.preload = 'auto';
    video.width = 2560; video.height = 1440; video.style.opacity = '0';
    image.after(video);

    function stopWork() {
      cancelAnimationFrame(raf); raf = 0;
      clearTimeout(loadTimer); loadTimer = 0;
      clearTimeout(seekTimer); seekTimer = 0;
      video.pause();
    }
    function unloadVideo() {
      stopWork(); loaded = false;
      video.removeAttribute('src'); video.load();
      video.style.opacity = '0'; image.style.opacity = '';
    }
    function fail() {
      if (destroyed || fallback) return;
      unloadVideo(); video.remove();
      fallback = createFallback();
      fallback?.setEnabled(enabled); fallback?.setProgress(progress);
    }
    function showFrame() {
      if (!working() || video.readyState < 2) return;
      video.style.opacity = '1'; image.style.opacity = '0';
    }
    function armSeekTimeout() {
      if (!seekTimer) seekTimer = setTimeout(() => { seekTimer = 0; if (working()) fail(); }, 2500);
    }
    function seek() {
      raf = 0;
      if (!working() || !loaded) return;
      // Let the decoder finish its current short seek, then catch up to the latest target.
      // Restarting it on every scroll tick can starve visible frames on slower phones.
      if (video.seeking) { armSeekTimeout(); return; }
      const start = startAt();
      const index = start + Math.round(progress * (count - start - 1));
      // Seek inside the frame: WebM timestamps are rounded to milliseconds.
      const time = (index + .5) * video.duration / count;
      if (Math.abs(video.currentTime - time) < .001) { showFrame(); return; }
      try { video.currentTime = time; armSeekTimeout(); } catch (_) { fail(); }
    }
    function queue() { if (working() && loaded && !raf) raf = requestAnimationFrame(seek); }
    function update() {
      if (!working()) { stopWork(); return; }
      if (!video.getAttribute('src')) { video.src = source; video.load(); }
      if (!loaded && !loadTimer) loadTimer = setTimeout(() => { loadTimer = 0; if (working()) fail(); }, 15000);
      queue();
    }
    function ready() {
      if (destroyed || fallback || !video.getAttribute('src') || !Number.isFinite(video.duration) || !video.duration) return;
      loaded = true; clearTimeout(loadTimer); loadTimer = 0; queue();
    }
    function onSeeked() {
      clearTimeout(seekTimer); seekTimer = 0;
      showFrame(); queue();
    }
    function setProgress(value) {
      progress = Math.max(0, Math.min(1, Number(value) || 0));
      image.dataset.lastScrollProgress = String(progress);
      for (const el of [image, video]) el.classList.toggle('is-scroll-visible', mobile.matches || progress > 0);
      if (fallback) fallback.setProgress(progress); else queue();
    }
    video.addEventListener('loadeddata', ready);
    video.addEventListener('seeked', onSeeked);
    video.addEventListener('error', fail);
    document.addEventListener('visibilitychange', update);
    if (window.IntersectionObserver) {
      observer = new IntersectionObserver(entries => { near = entries.some(entry => entry.isIntersecting); update(); }, { rootMargin: '200% 0px' });
      observer.observe(scene);
    }
    setProgress(0); update();
    return {
      setProgress,
      refresh() { if (fallback) fallback.refresh(); else { setProgress(progress); update(); } },
      setEnabled(value) {
        enabled = value;
        if (fallback) fallback.setEnabled(value);
        else if (!enabled) unloadVideo();
        else update();
      },
      destroy() {
        if (destroyed) return;
        destroyed = true; observer?.disconnect();
        document.removeEventListener('visibilitychange', update);
        video.removeEventListener('loadeddata', ready); video.removeEventListener('seeked', onSeeked); video.removeEventListener('error', fail);
        unloadVideo(); video.remove(); fallback?.destroy();
      }
    };
  };
})();
